import { defaultPalette, sizes } from '@guryou/html-theme';
import styled from 'styled-components';
import propsToCss from '../utils/propsToCss';
export const Image = styled.img`
  width: 100%;
  ${props => propsToCss(props)};
`;
export const ImageSmall = styled.img`
  max-width: 30px;
  ${props => propsToCss(props)};
`;
export const ImageThumbnail = styled.img`
  max-width: 100px;
  ${props => propsToCss(props)};
`;
export const ImageThumbnailRoundedCorners = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 15%;
  ${props => propsToCss(props)};
`;
export const ImageRoundThumbnail = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  ${props => propsToCss(props)};
`;
export const ImageMedium = styled.img`
  max-width: ${sizes.small}px;
  width: auto;
  height: auto;
  display: block;
  ${props => propsToCss(props)};
`;
export const FullWidthImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  ${props => propsToCss(props)};
`;
export const ImageLogo = styled.img`
  max-width: 170px;
  &:hover {
    cursor: pointer;
  }
  ${props => propsToCss(props)}
`;
export const Svg = styled.svg`
  ${props => propsToCss(props)};
`;

// Obsolete
export const ProviderImageInfo = styled.div`
  width: ${props => props.width || '70px'};
  height: ${props => props.height || '70px'};
  border-radius: ${props => props.borderRadius || '50%'};
  border: ${props => props.activeStatus !== undefined && `2px solid ${defaultPalette[props.activeStatus ? 'success' : 'error'].main}`};
  background-image: ${props => `url('${props.bg}')`};
  background-size: ${props => !props.bg.includes('http') ? '70% 70%' : 'cover'};
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: 0.5rem;
`;